import React from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from 'Shared/atoms'
import Spinner from 'Shared/atoms/Spinner'

import styles from './input.module.scss'

interface Props {
	isSearch?: boolean
	isLoading?: boolean
}

function NotFoundContent({ isSearch, isLoading = false }: Props) {
	const { t } = useTranslation()

	if (isLoading) {
		return <Spinner className={styles.spinner} />
	}
	return (
		<div className={styles.notFoundContent}>
			<Icon type="notFoundContent" className={styles.icon} />
			<span className={styles.notFoundText}>
				{isSearch ? t('core:labels.noResult') : t('core:labels.noData')}
			</span>
		</div>
	)
}

export default NotFoundContent
